import 'imagesloaded/imagesloaded.pkgd.min';
import 'infinite-scroll/dist/infinite-scroll.pkgd.min';
import '@fancyapps/fancybox';
import Swiper from 'swiper';
import { setupCtaTracking } from '../modules/ctaTracking';

export default {
    init() {
      // JavaScript to be fired on all pages
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
      $('[data-fancybox]').fancybox();

        function updateURLParameter(url, param, paramVal) {
            var TheAnchor = null;
            var newAdditionalURL = '';
            var tempArray = url.split('?');
            var baseURL = tempArray[0];
            var additionalURL = tempArray[1];
            var temp = '';
            var tmpAnchor;
            var TheParams;

            if (additionalURL)
            {
                tmpAnchor = additionalURL.split('#');
                TheParams = tmpAnchor[0];
                TheAnchor = tmpAnchor[1];

                if(TheAnchor)
                    additionalURL = TheParams;

                tempArray = additionalURL.split('&');

                for (var i=0; i<tempArray.length; i++)
                {
                    if(tempArray[i].split('=')[0] != param)
                    {
                        newAdditionalURL += temp + tempArray[i];
                        temp = '&';
                    }
                }
            }
            else
            {
                tmpAnchor = baseURL.split('#');
                TheParams = tmpAnchor[0];
                TheAnchor  = tmpAnchor[1];

                if(TheParams)
                    baseURL = TheParams;
            }

            if(TheAnchor)
                paramVal += '#' + TheAnchor;

            var rows_txt = temp + '' + param + '=' + paramVal;
            return baseURL + '?' + newAdditionalURL + rows_txt;
        }

        $('.holidays__filter-dd.--country').select2({
            placeholder: 'Select country...',
            dropdownParent: '.holidays__filter-item.--country',
            width: '100%',
        });

        $('.holidays__filter-dd.--price').select2({
            placeholder: 'Sort Price...',
            minimumResultsForSearch: Infinity,
            dropdownParent: '.holidays__filter-item.--price',
            width: '100%',
        });

        $('.holidays__filter-dd').on('select2:select', function() {
            var newUrl = window.location.href.replace(location.hash, '').replace(/\/page\/([0-9])/, '');

            if( $('.holidays__filter-dd.--country').val() ) {
                newUrl = updateURLParameter(newUrl, 'country', $('.holidays__filter-dd.--country').val());
            }

            if( $('.holidays__filter-dd.--price').val() ) {
                newUrl = updateURLParameter(newUrl, 'sort', $('.holidays__filter-dd.--price').val());
            }

            window.location = newUrl+'#tripList';
        });

        $(document).on('load scroll', function () {
            if ( $(window).scrollTop() > 0 ) {
                $('body').addClass('--scrolled');
            } else {
                $('body').removeClass('--scrolled');
            }
        });

        $('.hamburger').on('click', function () {
            $(this).toggleClass('is-active');
            $('body').toggleClass('no-scroll');
            $('.banner').toggleClass('menu-open');
        });

        $('.back-to-top').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $('body').offset().top,
            }, 800);
        });

        $('.category-select').on('change', function () {
            var target = $(this).val();
            $('html, body').animate({
                scrollTop: $(target).offset().top - 100,
            }, 800);
        });

        $('.category__wrap').infiniteScroll({
            path: '.category__footer a',
            append: '.post-card',
            hideNav: '.category__footer a',
          });

        $('.category__wrap').on('last.infiniteScroll', function () {
            $('.category__footer').hide();
        });

        /**
         * Our Favourites Carousel
         * Loop through so we can have multiple on a page
         * /
         **/
        const ourFavourites = ()=> {
            let wrap = document.querySelectorAll('.our-favourites');
            
            wrap.forEach((wrapper)=>{
                let slider = wrapper.querySelector('.swiper-container');
                let prevArrow = wrapper.querySelector('.our-favourites__prev');
                let nextArrow = wrapper.querySelector('.our-favourites__next');
                
                new Swiper(slider, {
                    loop: true,
                    spaceBetween: 36,
                    slidesPerView: 1.3,
                    // Navigation arrows
                    navigation: {
                        nextEl: nextArrow,
                        prevEl: prevArrow,
                    },
                    breakpoints: {
                        570: {
                            slidesPerView: 2,
                        },
                        1040: {
                            slidesPerView: 4,
                        },
                    },
                }); 
            })
        }
        window.addEventListener('load', ourFavourites)

        //
        // Mobile Menu Toggle
        //
        $(document).on('click', '.mega-menu__mobile-dropdown', function () {
            var cla = 'mega-menu__panel--toggled';
            var clb = 'mega-menu__item--toggled';
            var el = jQuery('[data-toggled-by="' + jQuery(this).attr('data-toggles') + '"]');
            if (jQuery(el).hasClass(cla)) {
                jQuery(el).removeClass(cla);
                jQuery(this).parent().removeClass(clb);
            } else {
                jQuery('.' + cla).removeClass(cla);
                jQuery('.' + clb).removeClass(clb);
                jQuery(el).addClass(cla);
                jQuery(this).parent().addClass(clb);
            }
        });

        //
        // Mobile Sub Menu Toggled
        //
        $(document).on('click', '.mega-menu__sub-mobile-dropdown', function () {
            var cla = 'mega-menu__sub-sub-items--toggled';
            var clb = 'mega-menu__sub-item--toggled';
            var el = jQuery('[data-toggled-by="' + jQuery(this).attr('data-toggles') + '"]');
            if (jQuery(el).hasClass(cla)) {
                jQuery(el).removeClass(cla);
                jQuery(this).parent().removeClass(clb);
            } else {
                jQuery('.' + cla).removeClass(cla);
                jQuery('.' + clb).removeClass(clb);
                jQuery(el).addClass(cla);
                jQuery(this).parent().addClass(clb);
            }
        });

        //
        // Mobile Menu Swiper - Right Column
        //
        $('.mega-menu__right-column-swiper-container').each(function (item, value) {
            new window.Swiper(
                value,
                {
                    loop: false,
                    slidesPerView: 1.2,
                    spaceBetween: 36,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    // keyboard control
                    keyboard: {
                        enabled: true,
                    },
                    observer: true,
                    observeParents: true,
                    on: {
                        beforeInit: () => {
                            $(value).closest('.mega-menu__panel').addClass('mega-menu__panel--force-toggled');
                        },
                        afterInit: () => {
                            $(value).closest('.mega-menu__panel').removeClass('mega-menu__panel--force-toggled');
                            $(value).css('visibility', 'visible');
                        },
                    },
                    breakpoints: {
                        570: {
                            slidesPerView: 2.2,
                        },
                        750: { // next is lg @ 1040
                            slidesPerView: 3,
                        },
                    },
                }
            );
        });

        //
        // Mobile Menu Swiper - One Column
        //
        $('.mega-menu__one-column-swiper-container').each(function (item, value) {
            new window.Swiper(
                value,
                {
                    loop: false,
                    slidesPerView: 1.5,
                    spaceBetween: 36,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                  // keyboard control
                    keyboard: {
                        enabled: true,
                    },
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: '.mega-menu__one-column-swiper-button.swiper-button-next',
                        prevEl: '.mega-menu__one-column-swiper-button.swiper-button-prev',
                    },
                    on: {
                        beforeInit: () => {
                            $(value).closest('.mega-menu__panel').addClass('mega-menu__panel--force-toggled');
                        },
                        afterInit: () => {
                            $(value).closest('.mega-menu__panel').removeClass('mega-menu__panel--force-toggled');
                            $(value).css('visibility', 'visible');
                        },
                    },
                    breakpoints: {
                        570: {
                            slidesPerView: 2.5,
                        },
                        750: { // next is lg @ 1040
                            slidesPerView: 3.5,
                        },
                        1040: {
                            slidesPerView: 5,
                        },
                    },
                }
            );
        });

        //
        // Debounce resize
        //
        var resizeTimer;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                $('.mega-menu__right-column-swiper-container').each(function (item, value) {
                    $(value).closest('.mega-menu__panel').addClass('mega-menu__panel--force-toggled');
                    value.swiper.update();
                    $(value).closest('.mega-menu__panel').removeClass('mega-menu__panel--force-toggled');
                });

                $('.mega-menu__one-column-swiper-container').each(function (item, value) {
                    $(value).closest('.mega-menu__panel').addClass('mega-menu__panel--force-toggled');
                    value.swiper.update();
                    $(value).closest('.mega-menu__panel').removeClass('mega-menu__panel--force-toggled');
                });
            }, 100);
        });

        jQuery(document).on('click', '.features__link', function () {
            jQuery(this).closest('.features').toggleClass('features--expanded');
        });

        jQuery(document).on('click', '.collections-vertical-listing__link', function () {
          jQuery(this).closest('.collections-vertical-listing').toggleClass('collections-vertical-listing--expanded');
        });

        //
        // CTA Tracking
        //
        setupCtaTracking();

        //
        // Dashboard - Next
        //
        jQuery(document).on('click', '.dashboard-main__next', function () {
           // Check the scroll left position of .dashboard-main__menu-items
            var scrollLeft = jQuery('.dashboard-main__menu-items').scrollLeft();
            // For each of the .dashboard-main__menu-item elements
            jQuery('.dashboard-main__menu-item:visible').each(function (index, value) {
                // Compare the left position of the element to the scroll left position
                // If the left position is greater than the scroll left position
                if (jQuery(value)[0].offsetLeft > scrollLeft) {
                    // Scroll to the left position of the element
                    jQuery('.dashboard-main__menu-items').scrollLeft(jQuery(value)[0].offsetLeft);
                    // Break the loop
                    return false;
                }
            });
        });

        //
        // Footer - New
        //
        jQuery('.footer-new .widget.nav_menu-2.widget_nav_menu .widget__header').click(function () {
            jQuery('.footer-new').toggleClass('footer-new--toggled');
        });
    },
};
